const colors = {
    primary: '#0E86D4',
    fontPrimary: 'text-sky-700',
    lightPrimary:'bg-sky-200'
}
export default colors